import { create } from 'zustand';

import type { AccountUsage } from '@/types/account-usage';
import type { CreditStatus } from '@/types/shared';

interface AccountLimitsStore {
  accountUsage: AccountUsage | null;
  aiCreditStatus: CreditStatus | null;

  setAccountUsage: (accountUsage: AccountUsage | null) => void;
  setAiCreditStatus: (aiCreditStatus: CreditStatus | null) => void;
  reset: () => void;
}

export const useAccountLimitsStore = create<AccountLimitsStore>((set) => ({
  accountUsage: null,
  aiCreditStatus: null,

  setAccountUsage: (accountUsage) => set({ accountUsage }),
  setAiCreditStatus: (aiCreditStatus) => set({ aiCreditStatus }),
  reset: () => set({ accountUsage: null, aiCreditStatus: null }),
}));

export function useAccountUsage<T>(selector: (accountUsage: AccountUsage | null) => T): T {
  return useAccountLimitsStore((state) => selector(state.accountUsage));
}

export function useAiCreditStatus(): CreditStatus | null {
  return useAccountLimitsStore((state) => state.aiCreditStatus);
}
